import { BRAND } from 'constants/appConstants'
import styled, { css } from 'styled-components'
import { theme } from 'utils/theme'

export const RelatedContentContainer = styled.div`
  padding: 24px 0;
`

export const RelatedTitle = styled.h2`
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 24px;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          color: ${theme.colors.lightGold};
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 700;
          color: ${theme.colors.white};
        `}
`
